import { useEffect, useState } from "react";
import { Outlet, Route, Routes, Navigate, useLocation, matchPath } from "react-router-dom";
import { useIsOpenSidebar, useIsOpenSidebarAction } from "../context/toggleSidebarContext";
import { useAuth } from "../context/AuthContext";
import { useSweetAlert } from "../context/sweetAlertContext";
import { panelRoutes } from "../routes";
import { userShowMessage } from "../services";
import DashboardStart from "../pages/DashboardStart";
import SidebarPublic from "../components/Sidebar/index-public";
import HeaderPublic from "../components/Header/indexPublic";
import FooterPublic from "../components/Footer/IndexPublic";
import Loading from "../components/Loading";

export default function AdminLayoutPublic({ children }) {
    const isShowSidebar = useIsOpenSidebar();
    const setIsOpenSidebar = useIsOpenSidebarAction();
    const { user, isLoading } = useAuth();
    const sweetAlert = useSweetAlert();
    const [notificationList, setNotificationList] = useState([]);
    const { pathname, search } = useLocation();

    const isPublicRoute = panelRoutes.some(route =>
        route.isPublic && matchPath({ path: route.path, end: true }, pathname)
    );

    useEffect(() => {
        const currentTitle = panelRoutes.find(item => item.path === pathname);
        if (currentTitle && currentTitle.title) {
            document.title = currentTitle.title;
        }

        if (isShowSidebar?.expanded) {
            setIsOpenSidebar({ ...isShowSidebar, expanded: false });
        }
    }, [pathname, search]);

    useEffect(() => {
        const handleOffline = () => {
            sweetAlert({
                show: true,
                title: "قطع ارتباط",
                icon: "error",
                text: "اتصال شما با اینترنت قطع شد.",
                confirmButtonText: "بارگذاری مجدد",
                onConfirm: () => window.location.reload()
            });
        };
        window.addEventListener("offline", handleOffline);
        return () => window.removeEventListener("offline", handleOffline);
    }, []);

    useEffect(() => {
        const html = document.querySelector('html');
        if (isShowSidebar?.expanded) {
            html.className = 'light-style layout-navbar-fixed layout-menu-fixed layout-menu-expanded';
        } else if (isShowSidebar?.collapsed && !isShowSidebar?.hovered) {
            html.className = 'light-style layout-navbar-fixed layout-menu-fixed layout-menu-collapsed';
        } else if (isShowSidebar?.collapsed && isShowSidebar?.hovered) {
            html.className = 'light-style layout-navbar-fixed layout-menu-fixed layout-menu-collapsed layout-menu-hover';
        } else {
            html.className = 'light-style layout-navbar-fixed layout-menu-fixed';
        }
    }, [isShowSidebar]);

    const closeSidebar = () => {
        setIsOpenSidebar({ ...isShowSidebar, expanded: false });
    };

    const getMessage = async (id = null) => {
        if (!user?.userPermission?.some(x => x === "MessageUserShowMessage")) return;
        try {
            const values = { id };
            const { data, status } = await userShowMessage(values);
            if (status === 200) {
                const newNotifications = [...notificationList];
                const item = newNotifications.find(x => x.id === data.id);
                if (item) {
                    item.seen = true;
                    setNotificationList(newNotifications);
                }
                sweetAlert({
                    show: true,
                    text: `${data.text}`,
                    confirmButtonText: "مشاهده شد",
                    marginTop: "20px",
                    onConfirm: () => {
                        if (id == null) getMessage();
                    }
                });
            }
        } catch (ex) {}
    };

    if (isLoading) {
        return <Loading />;
    }

    // نکته کلیدی: اگر کاربر لاگین است، روت‌های پابلیک باید در ادمین پنل اصلی (AdminLayout) باز شوند
    if (user) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SidebarPublic />

                <div className="layout-page">
                    <div>
                        <HeaderPublic />

                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <Routes>
                                    {panelRoutes
                                        .filter(route => route.isPublic)
                                        .map(route => (
                                            <Route
                                                key={route.id}
                                                path={route.path}
                                                element={<route.component getMessage={getMessage} />}
                                            />
                                        ))}

                                    <Route path="/*" element={<DashboardStart />} />
                                </Routes>

                                <Outlet />
                                {children}
                            </div>
                            <FooterPublic />
                            <div className="content-backdrop fade" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="layout-overlay layout-menu-toggle" onClick={closeSidebar} />
            <div className="drag-target h-100-px" />
        </div>
    );
}
